import Laptop from './Laptop'

export default Laptop
// eslint-disable-next-line import/export
export * from './Laptop'
